// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bba_a","InstagramEmbed__mask":"bba_b bht_bi bht_bo bht_vt"};